import { createContext, useEffect, useRef, useState } from 'react'
import { observer } from 'mobx-react'
import { Cartographic, Cesium3DTileset, Resource, ScreenSpaceEventHandler, ScreenSpaceEventType, WebMapServiceImageryProvider } from '@cesiumgs/cesium-analytics'
import * as Cesium from '@cesiumgs/cesium-analytics'
import { Button, InputNumber, Popover, Radio } from 'antd'
import * as turf from '@turf/turf'
import {
  AN1,
  AN2,
  AN3,
  AN4,
  AN5,
  AN6,
  CAMERA_HEIGHT,
  ME1,
  ME2,
  ME3,
  ME4,
  ME5,
  POLYGON_HIDE_HEIGHT,
  addressArr as addressArrCopy,
  areaList,
  contentArr2 as contentArr2Copy,
  contentArr3 as contentArr3Copy,
  contentArr4 as contentArr4Copy,
  contentArr5 as contentArr5Copy,
  contentArr6 as contentArr6Copy,
  contentArr7 as contentArr7Copy,
  icon_an1_off,
  icon_an1_on,
  icon_an2_off,
  icon_an2_on,
  icon_an3_off,
  icon_an3_on,
  icon_an4_off,
  icon_an4_on,
  icon_an5_off,
  icon_an5_on,
  icon_an6_off,
  icon_an6_on,
  icon_analyze_off,
  icon_analyze_on,
  icon_area,
  icon_area_on,
  icon_building,
  icon_building_on,
  icon_close,
  icon_compass,
  icon_lod_off,
  icon_lod_on,
  icon_me1_off,
  icon_me1_on,
  icon_me2_off,
  icon_me2_on,
  icon_me3_off,
  icon_me3_on,
  icon_me4_off,
  icon_me4_on,
  icon_me5_off,
  icon_me5_on,
  icon_measure_off,
  icon_measure_on,
  icon_minus,
  icon_model_off,
  icon_model_on,
  icon_pen,
  icon_pen_on,
  icon_plus,
  icon_screen,
  landRatioArr,
  navigation_outline,
  shadow_off,
  shadow_on,
} from './data'
import provinceData from './provinceLayer.json'
import AnalysisAndMeasure from './analysisAndMeasure'
import Loading from './loading'

import RenderKeyValue2Array2 from './RenderKeyValue2Array2'
import useStore from '@/hooks/useStore'
import {
  checkOverlab_3dtiles,
  getCenterPosition, worldToLngLat,
} from '@/utils/rightNavCtrl'
import {
  IGetBusiness,
  // IGetPlotData,
  IGetPopulation,
  getPositionPUN,
  handleDownload,
  queryIntersects,
  // querySpatial,
  // IAjaxLogin,
} from '@/service/rightNavCtrl'
import Draw from '@/components/Cesium/Draw/Draw'
import { DrawType } from '@/components/Cesium/Draw/DrawType'
import { DrawEventType } from '@/components/Cesium/Draw/DrawEventType'
import Modal from '@/components/Modal'
import RenderKeyValue2Array from '@/components/Content/RenderKeyValue2Array'

import './RightNavCtrl.less'

interface IProps {
  viewer: Cesium.Viewer
}

export const rightNavContext = createContext<any>(null)

const prefix = 'right_nav'
const ON = ' ON'
const OFF = ' OFF'
const SHADOW_TEXT = '음영'
const LOD1_TEXT = 'LOD1'
let moveLod1Handler: any = null
const TIME_OUT = 300
let cesium3dTileFeature: any = []
let polygonDataSource: any = null
let dataSourcePolygon: any = []
const AREA_POLYGON = 'AREA_POLYGON'
const BUILDING_POLYGON = 'BUILDING_POLYGON'
const POLYGON = 'POLYGON'
const LABEL = 'LABEL'
let areaDataSource: any = null
let buildingDataSource: any = null
let AREA_NUM = 0 // for entity label text num
let BUILDING_NUM = 0 // for entity label text num
let areaDrawTool: any = null
let buildingDrawTool: any = null
let areaAction: any = null
let buildingAction: any = null
let pickBillboardArea: any = null
const POLYGON_COLOR = '#ccd120'
const SPLIT_NAME = '건물'
let currentBuildingEntity: any = null
let mouseMoveEvent: any = null
let mouseClickEvent: any = null
let mouseWheelEvent: any = null
const PROVINCE_ENTITY = 'PROVINCE_ENTITY'
const TAB1 = 'tab1'
const TAB2 = 'tab2'
let lodClickEvent: any = null
let circleCount = 0 // 화면에 표시된 원의 개수
let circlePolygon: any = null // 원의 폴리곤 정보
let entityCenterLonLat: any = null

function RightNavCtrl(props: IProps) {
  // eslint-disable-next-line n/prefer-global/process
  const isDev = process.env.NODE_ENV === 'development'
  const { viewer } = props
  const rightNavCtrlStore = useStore('rightNavCtrlStore')
  const measureStore = useStore('measureStore')
  const uiStore = useStore('uiStore')
  const facilityStore = useStore('facilityStore')
  const mapStore = useStore('mapStore')
  const analysisAndMeasureRef: any = useRef(null)

  const { currentVisible } = rightNavCtrlStore
  const { isClosedMeasure } = measureStore
  const [isShadow, setIsShadow] = useState(false)
  const [isLod1, setIsLod1] = useState(false)
  const [isModel, setIsModel] = useState(false)
  const [isAnalysisPopover, setIsAnalysisPopover] = useState(false)
  const [isMeasurePopover, setIsMeasurePopover] = useState(false)
  const [isEditPopover, setIsEditPopover] = useState(false)
  const [openModel, setOpenModel] = useState(false)
  const [isAn1, setIsAn1] = useState(false)
  const [isAn2, setIsAn2] = useState(false)
  const [isAn3, setIsAn3] = useState(false)
  const [isAn4, setIsAn4] = useState(false)
  const [isAn5, setIsAn5] = useState(false)
  const [isAn6, setIsAn6] = useState(false)
  const [isMe1, setIsMe1] = useState(false)
  const [isMe2, setIsMe2] = useState(false)
  const [isMe3, setIsMe3] = useState(false)
  const [isMe4, setIsMe4] = useState(false)
  const [isMe5, setIsMe5] = useState(false)
  const [wmsLayerName, setWmsLayerName] = useState('')
  const [wmsLayerName2, setWmsLayerName2] = useState('')
  const [cadastral, setCadastral] = useState<any>(false)
  const [isLoading, setIsLoading] = useState<any>(false)
  const [lod1Tilset, setLod1Tilset] = useState<any>(null)
  const [deg, setDeg] = useState(0)
  const [loading, setLoading] = useState(false)
  const [loading2, setLoading2] = useState(false)
  const [isClickArea, setIsClickArea] = useState(false)
  const [isClickBuilding, setIsClickBuilding] = useState(false)
  const [isShowModal, setIsShowModal] = useState(false)
  const [isShowModal2, setIsShowModal2] = useState(false)
  const [inputValue, setInputValue] = useState(10)
  const [centerPoint, setCenterPoint] = useState<any>(null)
  const [activeTab, setActiveTab] = useState(TAB1)
  const [contentArr2, setContentArr2] = useState<any>(contentArr2Copy)
  const [contentArr3, setContentArr3] = useState<any>(contentArr3Copy)
  const [contentArr4, setContentArr4] = useState<any>(contentArr4Copy)
  const [contentArr5, setContentArr5] = useState<any>(contentArr5Copy)
  const [contentArr6, setContentArr6] = useState<any>(contentArr6Copy)
  const [contentArr7, setContentArr7] = useState<any>(contentArr7Copy)
  const [populationArr, setPopulationArr] = useState<any>([])
  const [businessArr, setBusinessArr] = useState<any>([])
  const [title, setTitle] = useState('')
  const [isClickPlot, setIsClickPlot] = useState(false)
  const [addressArr, setAddressArr] = useState<any>(addressArrCopy)
  const [radioValue, setRadioValue] = useState('')
  const [showProvince, setShowProvince] = useState(false)

  useEffect(() => {
    // IAjaxLogin().then((res) => {
    // })
    const heading = Cesium.Math.toDegrees(viewer.camera.heading)
    setDeg(Number.parseInt(heading.toString()))
    viewer.camera.changed.addEventListener(() => {
      const heading1 = Cesium.Math.toDegrees(viewer.camera.heading)
      if (Number.parseInt(heading1.toString()) !== deg) {
        setDeg(Number.parseInt(heading1.toString()))
      }
    })
    polygonDataSource = new Cesium.CustomDataSource('dataSourceLayer')
    viewer.dataSources.add(polygonDataSource)
    areaDrawTool = new Draw(viewer)
    areaDataSource = new Cesium.CustomDataSource(AREA_POLYGON)
    viewer.dataSources.add(areaDataSource)
    buildingDrawTool = new Draw(viewer)
    buildingDataSource = new Cesium.CustomDataSource(BUILDING_POLYGON)
    viewer.dataSources.add(buildingDataSource)
    const url = window.location.href
    if (url.includes('ruralBusiness')) {
      //
    }
    else {
      // drawPolygon(provinceData.features)
      // const centerArr = getMultiplePolygonCenter(provinceData.features)
      // const centerPoint = getMultiplePointCenter(centerArr)
      // setCenterPoint(centerPoint)
      // watchMouseWheel()
    }
    // querySpatial().then((res) => {
    // })
    // calcLandRatio()
  }, [])

  useEffect(() => {
    if (!currentVisible) {
      clearAllAnalysis()
      setIsAnalysisPopover(false)
    }
  }, [currentVisible])

  useEffect(() => {
    if (isClosedMeasure) {
      clearAllMeasure()
      setIsMeasurePopover(false)
      measureStore.setIsClosedMeasure(false)
    }
  }, [isClosedMeasure])

  useEffect(() => {
    if (centerPoint) {
      flyToLayerAbove()
    }
  }, [centerPoint])

  useEffect(() => {
    if (isShowModal) {
      buildingAction && buildingAction.destroy()
    }
  }, [isShowModal])

  useEffect(() => {
    if (facilityStore.hideProvinceEntityNum !== 0) {
      hidePolygonDataSource()
    }
  }, [facilityStore.hideProvinceEntityNum])

  useEffect(() => {
    if (radioValue) {
      const find = addressArr.find((item: any) => item.value === radioValue)
      if (find) {
        const layersName = find.wmsLayerName
        setWmsLayerName2(layersName)
        const layers = (viewer.imageryLayers as any)._layers
        layers.forEach((item: any) => {
          if (item._imageryProvider._layers === wmsLayerName2) {
            viewer.imageryLayers.remove(item)
          }
        })
        const providerLayer = new WebMapServiceImageryProvider({
          url: window.SystemConfig.rightNavCtrlConfig.geoserverBaseWMSUrl,
          layers: layersName,
          parameters: {
            service: 'WMS',
            format: 'image/png',
            transparent: true,
          },
        })
        viewer.imageryLayers.addImageryProvider(providerLayer)
      }
    }
  }, [radioValue])

  useEffect(() => {
    if (rightNavCtrlStore.showPolygonOnMap) {
      showPolygonDataSource()
    }
    else {
      hidePolygonDataSource()
    }
  }, [rightNavCtrlStore.showPolygonOnMap])

  useEffect(() => {
    if (uiStore.isClickRural) {
      hidePolygonDataSource()
      mouseWheelEvent && mouseWheelEvent.destroy()
    }
  }, [uiStore.isClickRural])

  useEffect(() => {
    if (facilityStore.modeLoadedTileset !== '') {
      checkOverlab_3dtiles(viewer, facilityStore.modeLoadedTileset)
      facilityStore.modeLoadedTileset = ''
    }
  }, [facilityStore.modeLoadedTileset])

  /**
   * 테스트 코드 - 토지이용현황도 선택 후 바탕을 클릭하면 반경에 해당하는 원을 그리고 면적을 계산
   */
  const calcLandRatio = () => {
    const handler = new ScreenSpaceEventHandler(viewer.canvas)

    handler.setInputAction((e: any) => {
      const ray = viewer.camera.getPickRay(e.position)
      if (ray) {
        const position = viewer.scene.globe.pick(ray, viewer.scene)
        if (position) {
          const cartographic = Cartographic.fromCartesian(position)
          const lng = Cesium.Math.toDegrees(cartographic.longitude)
          const lat = Cesium.Math.toDegrees(cartographic.latitude)
          // changeCssStore({ pos: { lng, lat }, name: newlayserstr })

          const center = [lng, lat]
          const radius = 0.5
          const circle = turf.circle(center, radius, { steps: 10, units: 'kilometers', properties: { foo: 'bar' } })
          circlePolygon = circle
          circle.geometry.coordinates.forEach((item2: any, index2: number) => {
            let pointArr: any = []
            const pointArr2: any = []
            item2.forEach((element: any, index3: number) => {
              pointArr = element.flat(3)
              pointArr2.push(pointArr[0])
              pointArr2.push(pointArr[1])
            })
            const position = new Cesium.PolygonHierarchy(Cesium.Cartesian3.fromDegreesArray(pointArr2))
            let addEntity: any = null
            addEntity = new Cesium.Entity({
              id: `111_${circleCount++}`,
              name: 'circle',
              polygon: {
                hierarchy: position,
                material: new Cesium.ColorMaterialProperty(Cesium.Color.RED),
                heightReference: Cesium.HeightReference.CLAMP_TO_GROUND,
              },
              polyline: {
                positions: position.positions,
                width: 2,
                material: Cesium.Color.WHITE.withAlpha(0.3),
                clampToGround: true,
              },
            })
            polygonDataSource.entities.add(addEntity)
            showPolygonDataSource()
          })
        }

        // 전북 전체 지역 정보 중 circle과 겹치는 polygon 검색
        queryIntersects(circlePolygon).then((res: any) => {
          const landRatio = landRatioArr // 대시 비율 계산 배열
          let totalArea = 0 // 면적 합
          // 특정 레이어에서 circle과 겹치는 polygon 검색
          res.features.forEach((item: any, index2: number) => {
            const ucbPolygon = turf.polygon(item.geometry.coordinates[0])
            const inter = turf.intersect(circlePolygon, ucbPolygon)
            if (inter != null) {
              // 겹치는 부분의 면적 계산 (제곱미터)
              const calcArea = turf.area(inter)
              for (let i = 0; i < landRatio.length; i++) {
                const lrItem = landRatio[i]
                if (lrItem.value.includes(item.properties.UCB)) {
                  lrItem.area += calcArea
                  totalArea += calcArea
                }
              }

              // 겹치는 부분을 화면에 표시
              inter.geometry.coordinates.forEach((item2: any, index2: number) => {
                let pointArr: any = []
                const pointArr2: any = []
                item2.forEach((element: any, index3: number) => {
                  pointArr = element.flat(3)
                  pointArr2.push(pointArr[0])
                  pointArr2.push(pointArr[1])
                })
                const position = new Cesium.PolygonHierarchy(Cesium.Cartesian3.fromDegreesArray(pointArr2))
                let addEntity: any = null
                addEntity = new Cesium.Entity({
                  id: `111_${circleCount++}`,
                  name: 'circle',
                  polygon: {
                    hierarchy: position,
                    material: new Cesium.ColorMaterialProperty(Cesium.Color.BLUEVIOLET),
                    heightReference: Cesium.HeightReference.CLAMP_TO_GROUND,
                  },
                  polyline: {
                    positions: position.positions,
                    width: 2,
                    material: Cesium.Color.WHITE.withAlpha(0.3),
                    clampToGround: true,
                  },
                })
                polygonDataSource.entities.add(addEntity)
                showPolygonDataSource()
              })
            }
          })

          // area 값이 있는 항목의 비율 계산
          for (let i = 0; i < landRatio.length; i++) {
            const lrItem = landRatio[i]
            if (lrItem.area === 0)
              lrItem.ratio = '00%'
            else
              lrItem.ratio = `${(lrItem.area / totalArea * 100).toFixed(2)}%`
          }
        })
      }
    }, ScreenSpaceEventType.LEFT_CLICK)
  }

  const handleLoadProvince = () => {
    setShowProvince(!showProvince)
    if (!showProvince) {
      polygonDataSource = new Cesium.CustomDataSource('dataSourceLayer')
      viewer.dataSources.add(polygonDataSource)
      drawPolygon(provinceData.features)
      const centerArr = getMultiplePolygonCenter(provinceData.features)
      const centerPoint = getMultiplePointCenter(centerArr)
      setCenterPoint(centerPoint)
      watchMouseWheel()
    }
    else {
      hidePolygonDataSource()
      polygonDataSource && viewer.dataSources.remove(polygonDataSource)
      mouseWheelEvent && mouseWheelEvent.destroy()
    }
  }

  const watchMouseWheel = () => {
    mouseWheelEvent = new ScreenSpaceEventHandler(viewer.scene.canvas)
    mouseWheelEvent.setInputAction((e: any) => {
      const cameraPosition = viewer.camera.position
      const cameraCartographic = Cesium.Cartographic.fromCartesian(cameraPosition)
      if (cameraCartographic.height < POLYGON_HIDE_HEIGHT) {
        hidePolygonDataSource()
      }
      else {
        showPolygonDataSource()
      }
    }, ScreenSpaceEventType.WHEEL)
  }

  const getMultiplePolygonCenter = (data: any) => {
    const centerArr: any = []
    data.forEach((item: any) => {
      item.geometry.coordinates[0].forEach((item2: any) => {
        const polygon = turf.polygon([item2])
        const center = turf.centroid(polygon)
        centerArr.push(center)
      })
    })
    return centerArr
  }

  const getMultiplePointCenter = (centerArr: any) => {
    const features = turf.featureCollection(centerArr)
    const center = turf.center(features)
    return center
  }

  const handleArrowN = () => {
    viewer.camera.flyTo({
      destination: viewer.scene.camera.position,
      orientation: {
        heading: Cesium.Math.toRadians(0),
        pitch: viewer.scene.camera.pitch,
        roll: viewer.scene.camera.roll,
      },
      complete: () => {},
    })
  }

  const addSpecifiedStore = (str: string) => {
    const citycode = str.slice(0, 2)
    const newlayserstr = `LSMD_CONT_LDREG_${citycode}_202205`
    setWmsLayerName(newlayserstr)
    const layers = (viewer.imageryLayers as any)._layers
    layers.forEach((item: any) => {
      if (item._imageryProvider._layers === wmsLayerName) {
        viewer.imageryLayers.remove(item)
      }
    })
    const providerLayer = new WebMapServiceImageryProvider({
      url: window.SystemConfig.rightNavCtrlConfig.dtgeoserverBaseWMSUrl,
      layers: newlayserstr,
      parameters: {
        service: 'WMS',
        format: 'image/png',
        transparent: true,
      },
    })
    viewer.imageryLayers.addImageryProvider(providerLayer)
    const handler = new ScreenSpaceEventHandler(viewer.canvas)

    handler.setInputAction((e: any) => {
      const ray = viewer.camera.getPickRay(e.position)
      if (ray) {
        const position = viewer.scene.globe.pick(ray, viewer.scene)
        if (position) {
          const cartographic = Cartographic.fromCartesian(position)
          const lng = Cesium.Math.toDegrees(cartographic.longitude)
          const lat = Cesium.Math.toDegrees(cartographic.latitude)
          // changeCssStore({ pos: { lng, lat }, name: newlayserstr })
        }
      }
    }, ScreenSpaceEventType.LEFT_CLICK)

    handler.setInputAction(() => {
      handler && handler.destroy()
    }, ScreenSpaceEventType.RIGHT_CLICK)
  }

  const addSpecifiedStore2 = (str: string) => {
    const citycode = str.slice(0, 2)
    const newlayserstr = `Wdkn:LSMD_CONT_LDREG_${citycode}`
    setWmsLayerName(newlayserstr)
    const layers = (viewer.imageryLayers as any)._layers
    layers.forEach((item: any) => {
      if (item._imageryProvider._layers === wmsLayerName) {
        viewer.imageryLayers.remove(item)
      }
    })
    const providerLayer = new WebMapServiceImageryProvider({
      url: window.SystemConfig.rightNavCtrlConfig.dtgeoserverBaseWMSUrl2,
      layers: newlayserstr,
      parameters: {
        service: 'WMS',
        format: 'image/png',
        transparent: true,
      },
    })
    viewer.imageryLayers.addImageryProvider(providerLayer)
    const handler = new ScreenSpaceEventHandler(viewer.canvas)

    handler.setInputAction((e: any) => {
      const ray = viewer.camera.getPickRay(e.position)
      if (ray) {
        const position = viewer.scene.globe.pick(ray, viewer.scene)
        if (position) {
          const cartographic = Cartographic.fromCartesian(position)
          const lng = Cesium.Math.toDegrees(cartographic.longitude)
          const lat = Cesium.Math.toDegrees(cartographic.latitude)
          // changeCssStore({ pos: { lng, lat }, name: newlayserstr })
        }
      }
    }, ScreenSpaceEventType.LEFT_CLICK)

    handler.setInputAction(() => {
      handler && handler.destroy()
    }, ScreenSpaceEventType.RIGHT_CLICK)
  }

  const addImageLayer = async () => {
    if (!cadastral) {
      setLoading(true)
      const lnglat = getCenterPosition(viewer)
      let response = null
      try {
        response = await getPositionPUN(lnglat)
      }
      finally {
        setLoading(false)
      }
      if (
        response
        && response.data
        && response.data.returnCode === '200'
        && response.data.contents
        && response.data.contents.result
        && response.data.contents.result.jusoList
        && response.data.contents.result.jusoList.jusoList
        && response.data.contents.result.jusoList.jusoList.addrPnu
      ) {
        addSpecifiedStore(response.data.contents.result.jusoList.jusoList.addrPnu)
      }
      else {
        addSpecifiedStore2('5211114700105680001')
      }
    }
    else {
      const layers = (viewer.imageryLayers as any)._layers
      layers.forEach((item: any) => {
        if (item._imageryProvider._layers === wmsLayerName) {
          viewer.imageryLayers.remove(item)
        }
      })
    }
    setCadastral(!cadastral)
  }

  const handleClickShadow = () => {
    setIsShadow(!isShadow)
    if (!isShadow) {
      viewer.scene.globe.enableLighting = true
      viewer.shadows = true
      viewer.terrainShadows = Cesium.ShadowMode.ENABLED
      // viewer.scene.requestRender()
    }
    else {
      viewer.scene.globe.enableLighting = false
      viewer.shadows = false
      viewer.terrainShadows = Cesium.ShadowMode.DISABLED
      // viewer.scene.requestRender()
    }
  }

  const handleClickLod1 = () => {
    setIsLod1(!isLod1)
    if (!isLod1) {
      // setIsAnalysisPopover(false)
      setIsMeasurePopover(false)
      const {
        checked,
        node: { url, key },
      } = window.SystemConfig.rightNavCtrlConfig.lod1Config.checkedevent
      if (checked) {
        const lod1Data = viewer.scene.primitives.add(
          new Cesium3DTileset({
            url: new Resource({
              url,
              headers: {
                'Authorization': 'musls',
                'x-lpid': '',
                'x-upid': '',
                'x-uid': '',
                'x-lid': key,
              },
            }),
          }),
        )
        setLod1Tilset(lod1Data)
        // lod1과 검색의 시설물이 겹치는 경우, lod1의 모델을 숨김처리
        lod1Data.allTilesLoaded.addEventListener(() => {
          facilityStore.setModeTileset('lod1')
        })
        const selected: any = {
          feature: undefined,
          originalColor: new Cesium.Color(),
        }
        const highlighted: any = {
          feature: undefined,
          originalColor: new Cesium.Color(),
        }

        moveLod1Handler = viewer.screenSpaceEventHandler.setInputAction((movement: any) => {
          try {
            // If a feature was previously highlighted, undo the highlight
            if (Cesium.defined(highlighted.feature)) {
              highlighted.feature.color = highlighted.originalColor
              highlighted.feature = undefined
            }
            // Pick a new feature
            const pickedFeature = viewer.scene.pick(movement.endPosition)
            if (pickedFeature && pickedFeature instanceof Cesium.Cesium3DTileFeature && pickedFeature.tileset.basePath.includes('lod10729')) {
              if (Cesium.defined(selected.feature) && Cesium.defined(selected.originalColor)) {
                selected.feature.color = selected.originalColor
                selected.feature = undefined
              }
              if (pickedFeature !== selected.feature) {
                selected.feature = pickedFeature
                Cesium.Color.clone(pickedFeature.color, selected.originalColor)
                pickedFeature.color = Cesium.Color.YELLOW
              }
            }
          }
          catch (error) {}
        }, Cesium.ScreenSpaceEventType.MOUSE_MOVE)
      }
    }
    else {
      clearLod1()
    }
  }

  const clearLod1 = () => {
    if (lod1Tilset) {
      lod1Tilset.show = false
    }
    lod1Tilset && viewer.scene.primitives.remove(lod1Tilset)
    cesium3dTileFeature = []
    moveLod1Handler && moveLod1Handler.destroy()
    lodClickEvent && lodClickEvent.destroy()
  }

  const enableClickEvent = () => {
    lodClickEvent = new Cesium.ScreenSpaceEventHandler(viewer.canvas)
    lodClickEvent.setInputAction((movement: any) => {
      const pickingEntity = viewer.scene.pick(movement.position)
      if (pickingEntity instanceof Cesium.Cesium3DTileFeature) {
        pickingEntity.show = false
        cesium3dTileFeature.push(pickingEntity)
      }
    }, Cesium.ScreenSpaceEventType.LEFT_CLICK)
  }

  const closeModelFn = () => {
    if (!isModel) {
      setIsModel(true)
      setOpenModel(false)
      enableClickEvent()
    }
    else {
      setIsModel(false)
      setOpenModel(false)
      showFeatureArr()
      lodClickEvent && lodClickEvent.destroy()
    }
  }

  const clearExistEntityAndModal = () => {
    clearAreaAll()
    clearBuildingAll()
    // clear other entity
    if (rightNavCtrlStore.slopAnalysisDataSource) {
      rightNavCtrlStore.slopAnalysisDataSource.entities.removeAll()
    }
    if (rightNavCtrlStore.slopDirectionAnalysisDataSource) {
      rightNavCtrlStore.slopDirectionAnalysisDataSource.entities.removeAll()
    }
    // todo: close the modal
    if (analysisAndMeasureRef.current && analysisAndMeasureRef.current.handleDiffCloseModal) {
      analysisAndMeasureRef.current.handleDiffCloseModal()
    }
  }

  const handleClickModel = () => {
    setIsModel(!isModel)
    // if true, start left mouse click event, else remove left mouse click event
    if (!isModel) {
      setIsModel(true)
      setOpenModel(false)
      enableClickEvent()
      setIsAnalysisPopover(false)
      setIsMeasurePopover(false)
      setIsEditPopover(false)
    }
    else {
      setIsModel(false)
      setOpenModel(false)
      showFeatureArr()
      lodClickEvent && lodClickEvent.destroy()
    }
    clearExistEntityAndModal()
  }

  const handleClickAnalyze = () => {
    setIsAnalysisPopover(!isAnalysisPopover)
    if (!isAnalysisPopover) {
      clearAllAnalysis()
      setIsModel(false)
      setIsMeasurePopover(false)
      setIsEditPopover(false)
      // setIsLod1(false)
      // clearLod1()
    }
    clearExistEntityAndModal()
  }

  const handleClickMeasure = () => {
    setIsMeasurePopover(!isMeasurePopover)
    if (!isMeasurePopover) {
      clearAllMeasure()
      setIsModel(false)
      setIsAnalysisPopover(false)
      setIsEditPopover(false)
      // setIsLod1(false)
      // clearLod1()
    }
    clearExistEntityAndModal()
  }

  const handleClickEdit = () => {
    setIsEditPopover(!isEditPopover)
    if (!isEditPopover) {
      clearAllEdit()
      setIsModel(false)
      setIsAnalysisPopover(false)
      setIsMeasurePopover(false)
    }
    clearExistEntityAndModal()
  }

  const clearAllAnalysis = () => {
    setIsAn1(false)
    setIsAn2(false)
    setIsAn3(false)
    setIsAn4(false)
    setIsAn5(false)
    setIsAn6(false)
  }

  const clearAllMeasure = () => {
    setIsMe1(false)
    setIsMe2(false)
    setIsMe3(false)
    setIsMe4(false)
    setIsMe5(false)
  }

  const clearAllEdit = () => {
    setIsClickArea(false)
    setIsClickBuilding(false)
  }

  const showFeatureArr = () => {
    if (cesium3dTileFeature.length > 0) {
      cesium3dTileFeature.forEach((item: any) => {
        item.show = true
      })
    }
  }

  const openModelFn = (visible: boolean) => {
    setOpenModel(visible)
  }

  const renderAnalysis = () => {
    const handleClickIsAn = (type: string, flag: boolean) => {
      clearAllAnalysis()
      // clear other entity
      if (rightNavCtrlStore.slopAnalysisDataSource) {
        rightNavCtrlStore.slopAnalysisDataSource.entities.removeAll()
      }
      if (rightNavCtrlStore.slopDirectionAnalysisDataSource) {
        rightNavCtrlStore.slopDirectionAnalysisDataSource.entities.removeAll()
      }
      switch (type) {
        case AN1:
          setIsAn1(flag)
          setIsLoading(true)
          setTimeout(() => {
            setIsLoading(false)
            rightNavCtrlStore.setCurrentVisible(AN1)
          }, TIME_OUT)
          break
        case AN2:
          setIsAn2(flag)
          setIsLoading(true)
          setTimeout(() => {
            setIsLoading(false)
            rightNavCtrlStore.setCurrentVisible(AN2)
          }, TIME_OUT)
          break
        case AN3:
          setIsAn3(flag)
          setIsLoading(true)
          setTimeout(() => {
            setIsLoading(false)
            rightNavCtrlStore.setCurrentVisible(AN3)
          }, TIME_OUT)
          break
        case AN4:
          setIsAn4(flag)
          setIsLoading(true)
          setTimeout(() => {
            setIsLoading(false)
            rightNavCtrlStore.setCurrentVisible(AN4)
          }, TIME_OUT)
          break
        case AN5:
          setIsAn5(flag)
          setIsLoading(true)
          setTimeout(() => {
            setIsLoading(false)
            rightNavCtrlStore.setCurrentVisible(AN5)
          }, TIME_OUT)
          break
        case AN6:
          setIsAn6(flag)
          setIsLoading(true)
          setTimeout(() => {
            setIsLoading(false)
            rightNavCtrlStore.setCurrentVisible(AN6)
          }, TIME_OUT)
          break
        default:
          break
      }
    }
    return (
      <div className={`${prefix}-analyze-box`}>
        <Popover placement="top" content={'경사도 분석'}>
          {isAn1
            ? (
            <img alt="icon" src={icon_an1_on} className={`${prefix}-img`} onClick={() => handleClickIsAn('an1', false)} />
              )
            : (
            <img alt="icon" src={icon_an1_off} className={`${prefix}-img`} onClick={() => handleClickIsAn('an1', true)} />
              )}
        </Popover>
        <Popover placement="top" content={'경사방향분석'}>
          {isAn2
            ? (
            <img alt="icon" src={icon_an2_on} className={`${prefix}-img`} onClick={() => handleClickIsAn('an2', false)} />
              )
            : (
            <img alt="icon" src={icon_an2_off} className={`${prefix}-img`} onClick={() => handleClickIsAn('an2', true)} />
              )}
        </Popover>
        <Popover placement="top" content={'가시권 분석'}>
          {isAn3
            ? (
            <img alt="icon" src={icon_an3_on} className={`${prefix}-img`} onClick={() => handleClickIsAn('an3', false)} />
              )
            : (
            <img alt="icon" src={icon_an3_off} className={`${prefix}-img`} onClick={() => handleClickIsAn('an3', true)} />
              )}
        </Popover>
        <Popover placement="top" content={'스카이라인 분석'}>
          {isAn4
            ? (
            <img alt="icon" src={icon_an4_on} className={`${prefix}-img`} onClick={() => handleClickIsAn('an4', false)} />
              )
            : (
            <img alt="icon" src={icon_an4_off} className={`${prefix}-img`} onClick={() => handleClickIsAn('an4', true)} />
              )}
        </Popover>
        <Popover placement="top" content={'조망 분석'}>
          {isAn5
            ? (
            <img alt="icon" src={icon_an5_on} className={`${prefix}-img`} onClick={() => handleClickIsAn('an5', false)} />
              )
            : (
            <img alt="icon" src={icon_an5_off} className={`${prefix}-img`} onClick={() => handleClickIsAn('an5', true)} />
              )}
        </Popover>
        <Popover placement="top" content={'음영 분석'}>
          {isAn6
            ? (
            <img alt="icon" src={icon_an6_on} className={`${prefix}-img`} onClick={() => handleClickIsAn('an6', false)} />
              )
            : (
            <img alt="icon" src={icon_an6_off} className={`${prefix}-img`} onClick={() => handleClickIsAn('an6', true)} />
              )}
        </Popover>
      </div>
    )
  }

  const renderMeasure = () => {
    const handleClickIsMe = (type: string, flag: boolean) => {
      clearAllMeasure()
      measureStore.destroy()
      switch (type) {
        case ME1:
          setIsMe1(flag)
          setIsLoading(true)
          setTimeout(() => {
            setIsLoading(false)
            rightNavCtrlStore.setCurrentVisible(ME1)
            rightNavCtrlStore.setCurrentVisibleMeType(flag)
          }, TIME_OUT)
          break
        case ME2:
          setIsMe2(flag)
          setIsLoading(true)
          setTimeout(() => {
            setIsLoading(false)
            rightNavCtrlStore.setCurrentVisible(ME2)
            rightNavCtrlStore.setCurrentVisibleMeType(flag)
          }, TIME_OUT)
          break
        case ME3:
          setIsMe3(flag)
          setIsLoading(true)
          setTimeout(() => {
            setIsLoading(false)
            rightNavCtrlStore.setCurrentVisible(ME3)
            rightNavCtrlStore.setCurrentVisibleMeType(flag)
          }, TIME_OUT)
          break
        case ME4:
          setIsMe4(flag)
          setIsLoading(true)
          setTimeout(() => {
            setIsLoading(false)
            rightNavCtrlStore.setCurrentVisible(ME4)
            rightNavCtrlStore.setCurrentVisibleMeType(flag)
          }, TIME_OUT)
          break
        case ME5:
          setIsMe5(flag)
          setIsLoading(true)
          setTimeout(() => {
            setIsLoading(false)
            rightNavCtrlStore.setCurrentVisible(ME5)
            rightNavCtrlStore.setCurrentVisibleMeType(flag)
          }, TIME_OUT)
          break
        default:
          break
      }
    }
    return (
      <div className={`${prefix}-measure-box`}>
        <Popover placement="top" content={'거리 측정'}>
          {isMe1
            ? (
            <img alt="icon" src={icon_me1_on} className={`${prefix}-img`} onClick={() => handleClickIsMe('me1', false)} />
              )
            : (
            <img alt="icon" src={icon_me1_off} className={`${prefix}-img`} onClick={() => handleClickIsMe('me1', true)} />
              )}
        </Popover>
        <Popover placement="top" content={'높이 측정'}>
          {isMe2
            ? (
            <img alt="icon" src={icon_me2_on} className={`${prefix}-img`} onClick={() => handleClickIsMe('me2', false)} />
              )
            : (
            <img alt="icon" src={icon_me2_off} className={`${prefix}-img`} onClick={() => handleClickIsMe('me2', true)} />
              )}
        </Popover>
        <Popover placement="top" content={'면적 측정'}>
          {isMe3
            ? (
            <img alt="icon" src={icon_me3_on} className={`${prefix}-img`} onClick={() => handleClickIsMe('me3', false)} />
              )
            : (
            <img alt="icon" src={icon_me3_off} className={`${prefix}-img`} onClick={() => handleClickIsMe('me3', true)} />
              )}
        </Popover>
        <Popover placement="top" content={'부피 측정'}>
          {isMe4
            ? (
            <img alt="icon" src={icon_me4_on} className={`${prefix}-img`} onClick={() => handleClickIsMe('me4', false)} />
              )
            : (
            <img alt="icon" src={icon_me4_off} className={`${prefix}-img`} onClick={() => handleClickIsMe('me4', true)} />
              )}
        </Popover>
        <Popover placement="top" content={'표고 측정'}>
          {isMe5
            ? (
            <img alt="icon" src={icon_me5_on} className={`${prefix}-img`} onClick={() => handleClickIsMe('me5', false)} />
              )
            : (
            <img alt="icon" src={icon_me5_off} className={`${prefix}-img`} onClick={() => handleClickIsMe('me5', true)} />
              )}
        </Popover>
      </div>
    )
  }

  const handleDownloadPicture = async (params: any) => {
    const res = await handleDownload(params)
    let url = ''
    if (res.data.code === 200) {
      url = res.data.data.fileUrl
    }
    url = window.SystemConfig.rightNavCtrlConfig.flightUrl1 + url

    const x = new XMLHttpRequest()
    x.open('GET', url, true)
    x.responseType = 'blob'
    x.onload = function (e) {
      const url = window.URL.createObjectURL(x.response)
      const a = document.createElement('a')
      a.href = url
      a.download = 'download'
      a.click()
    }
    x.send()
  }

  const handleClickScreen = () => {
    const values = {
      width: 1920,
      height: 1080,
    }
    let blob: Blob = new Blob()
    try {
      blob = viewer.getBlob()
    }
    catch (error) {}
    const files = new window.File([blob], 'data.png')
    handleDownloadPicture({ files, ...values })
  }

  const clickZoomIn = (type: string) => {
    const pos = viewer.camera.position
    const cartographic = Cartographic.fromCartesian(pos)
    const z = cartographic.height
    let zoom = 1000
    if (z > 10000) {
      zoom = 10000
    }
    else if (z > 1000 && z <= 10000) {
      zoom = 1000
    }
    else if (z > 0 && z <= 1000) {
      zoom = 100
    }

    if (type === 'in') {
      if (z < 200) {
        return
      }
      viewer.camera.zoomIn(zoom)
    }
    else {
      viewer.camera.zoomOut(zoom)
    }
  }

  const getPlotData = () => {
    setIsClickPlot(!isClickPlot)
    if (!isClickPlot) {
      hidePolygonDataSource()
      mouseWheelEvent && mouseWheelEvent.destroy()
    }
    else {
      showPolygonDataSource()
      watchMouseWheel()
      const layers = (viewer.imageryLayers as any)._layers
      layers.forEach((item: any) => {
        if (item._imageryProvider._layers === wmsLayerName2) {
          viewer.imageryLayers.remove(item)
        }
      })
      setRadioValue('')
    }
    // setLoading2(true)
    // IGetPlotData()
    //   .then((res: any) => {
    //     if (res.mapServerIp && res.requestUrl) {
    //       setLoading2(false)
    //       const arr = res.requestQueryString.split('&')
    //       let layers = ''
    //       arr.forEach((item: any, index: number) => {
    //         if (item.includes('layers')) {
    //           layers = item.split('=')[1]
    //         }
    //       })
    //       const obj = {
    //         url: res.mapServerIp + res.requestUrl,
    //         layers,
    //         parameters: {
    //           service: 'WMS',
    //           format: 'image/png',
    //           transparent: true,
    //         },
    //       }
    //       const imageryProvider = new Cesium.WebMapServiceImageryProvider(obj)
    //       viewer.imageryLayers.addImageryProvider(imageryProvider)
    //     }
    //   })
    //   .finally(() => {
    //     setLoading2(false)
    //   })
  }

  const deleteDataSource = () => {
    if (polygonDataSource && polygonDataSource.entities) {
      polygonDataSource.entities.removeAll()
      dataSourcePolygon = []
    }
  }

  const drawPolygon = (data: any) => {
    if (Array.isArray(data) && data.length > 0) {
      deleteDataSource()
      let addEntity: any = null
      const opacity = 0.9
      const colorArr = ['#eb984a', '#e79065', '#f1b877', '#f4da7e', '#ecc473', '#ecc473', '#eca46e', '#f6dc7f', '#f6cb80', '#f1b877', '#dd6953', '#f1b877', '#f1b877', '#f1b877', '#f1b877']
      // defineProj('EPSG:5179', '+proj=tmerc +lat_0=38 +lon_0=127.5 +k=0.9996 +x_0=1000000 +y_0=2000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ')
      data.forEach((item: any, index: number) => {
        item.geometry.coordinates.forEach((item2: any, index2: number) => {
          let pointArr: any = []
          item2.forEach((element: any, index3: number) => {
            pointArr = element.flat(3)
            item.color = colorArr[index]
            const position = new Cesium.PolygonHierarchy(Cesium.Cartesian3.fromDegreesArray(pointArr))
            addEntity = new Cesium.Entity({
              id: `${PROVINCE_ENTITY}_${index}_${index2}_${index3}`,
              name: item.properties,
              polygon: {
                hierarchy: position,
                outline: true,
                outlineColor: Cesium.Color.WHITE,
                outlineWidth: 4,
                material: new Cesium.ColorMaterialProperty(Cesium.Color.fromCssColorString(item.color).withAlpha(opacity)),
                heightReference: Cesium.HeightReference.CLAMP_TO_GROUND,
              },
              polyline: {
                positions: position.positions,
                width: 2,
                material: Cesium.Color.WHITE.withAlpha(0.3),
                clampToGround: true,
              },
            })
            polygonDataSource.entities.add(addEntity)
            dataSourcePolygon.push(addEntity)
          })
        })
      })
      moveAndClick()
    }
  }

  const hidePolygonDataSource = () => {
    if (polygonDataSource && polygonDataSource.entities) {
      polygonDataSource.entities.values.forEach((item: any) => {
        item.show = false
      })
    }
  }

  const showPolygonDataSource = () => {
    if (polygonDataSource && polygonDataSource.entities) {
      polygonDataSource.entities.values.forEach((item: any) => {
        item.show = true
      })
    }
  }

  const clearPopulationAndBusiness = () => {
    setContentArr2(contentArr2Copy)
    setContentArr3(contentArr3Copy)
    setContentArr4(contentArr4Copy)
    setContentArr5(contentArr5Copy)
    setContentArr6(contentArr6Copy)
    setContentArr7(contentArr7Copy)
    setPopulationArr([])
    setBusinessArr([])
  }

  const moveAndClick = () => {
    const selected: any = {
      feature: undefined,
      originalColor: new Cesium.Color(),
    }

    mouseMoveEvent = new Cesium.ScreenSpaceEventHandler(viewer.scene.canvas)
    mouseClickEvent = new Cesium.ScreenSpaceEventHandler(viewer.scene.canvas)

    mouseClickEvent.setInputAction((movement: any) => {
      const pickClick = viewer.scene.pick(movement.position)
      if (pickClick && pickClick.id && pickClick.id.id && pickClick.id.id.includes(PROVINCE_ENTITY)) {
        const properties = pickClick.id.name
        const { ADM_SECT_C } = properties
        const find = areaList.find((item: any) => item.value === ADM_SECT_C)
        if (find) {
          const id = localStorage.getItem('JSESSIONID') || ''
          const obj2 = {
            apiKey: window.SystemConfig.facilityApiKey,
            sggCd: find.sggCd,
            sessionId: isDev ? `${window.SystemConfig.facilitySessionId}` : id,
          }
          clearPopulationAndBusiness()
          setActiveTab(TAB1)
          IGetPopulation(obj2).then((res: any) => {
            if (res.code === 200) {
              const arr = res.result.resultList || []
              if (arr.length > 0) {
                const find = arr.find((item: any) => item.emdNm === null)
                if (find) {
                  const arr2 = JSON.parse(JSON.stringify(contentArr2))
                  arr2[0][0].value = find.avgAge
                  arr2[0][1].value = find.agedChildIdx
                  arr2[1][0].value = Number(find.totFamily).toLocaleString()
                  arr2[1][1].value = Number(find.totPpltn).toLocaleString()
                  setContentArr2(arr2)
                  const arr3 = JSON.parse(JSON.stringify(contentArr3))
                  arr3[0][0].value = find.fper
                  arr3[0][1].value = find.mper
                  arr3[1][0].value = Number(find.fppl).toLocaleString()
                  arr3[1][1].value = Number(find.mppl).toLocaleString()
                  arr3[2][0].value = find.residPpltnPer
                  arr3[3][0].value = find.jobPpltnPer
                  arr3[4][0].value = find.onePersonFamilyPer
                  arr3[5][0].value = find.sixtyFiveMorePpltnPer
                  arr3[6][0].value = find.twentyPpltnPer
                  setContentArr3(arr3)
                  const title = `${find.sidoNm}_${find.sggNm}`
                  setTitle(title)
                }
                setPopulationArr(arr)
              }
              else {
                setContentArr2(contentArr2Copy)
                setContentArr3(contentArr3Copy)
                setPopulationArr([])
              }
              setIsShowModal2(true)
            }
          })
        }
      }
    }, Cesium.ScreenSpaceEventType.LEFT_CLICK)

    mouseMoveEvent.setInputAction((movement: any) => {
      const pickedFeature = viewer.scene.pick(movement.endPosition)
      if (pickedFeature && pickedFeature.id && pickedFeature.id.id && pickedFeature.id.id.includes(PROVINCE_ENTITY)) {
        if (Cesium.defined(selected.feature) && Cesium.defined(selected.originalColor)) {
          selected.feature.id.polygon.material.color = selected.originalColor
          selected.feature = undefined
        }
        if (pickedFeature !== selected.feature) {
          ;(viewer as any)._container.style.cursor = 'pointer'
          selected.feature = pickedFeature
          Cesium.Color.clone(pickedFeature.id.polygon.material.color._value, selected.originalColor)
          pickedFeature.id.polygon.material.color = Cesium.Color.fromCssColorString('#8c8847').withAlpha(0.9)
        }
      }
      else {
        ;(viewer as any)._container.style.cursor = 'default'
      }
    }, Cesium.ScreenSpaceEventType.MOUSE_MOVE)
  }

  const flyToLayerAbove = () => {
    if (!centerPoint)
      return
    viewer.camera.flyTo({
      destination: Cesium.Cartesian3.fromDegrees(centerPoint.geometry.coordinates[0], centerPoint.geometry.coordinates[1], CAMERA_HEIGHT),
      orientation: {
        heading: Cesium.Math.toRadians(0),
        pitch: Cesium.Math.toRadians(-90),
        // roll: viewer.scene.camera.roll,
        roll: 0,
      },
      duration: 3,
      complete: () => {},
    })
  }

  const areaDraw = () => {
    if (AREA_NUM > 4)
      return
    areaAction = areaDrawTool.create(DrawType.Polygon, {
      useDefaultEntity: true,
    })
    areaAction.on(DrawEventType.Complete, (evt: any) => {
      if (evt) {
        evt.push(evt[0])
        const arr = worldToLngLat(viewer, evt)
        const polygon = turf.polygon([arr])
        const rawCenter = turf.centerOfMass(polygon)
        const center = rawCenter.geometry.coordinates
        AREA_NUM++
        areaAction && areaAction.destroy()
        const addEntity = new Cesium.Entity({
          name: `${AREA_POLYGON}_${AREA_NUM}`,
          position: Cesium.Cartesian3.fromDegrees(center[0], center[1], 10),
          polygon: {
            hierarchy: new Cesium.PolygonHierarchy(evt),
            material: Cesium.Color.fromCssColorString(POLYGON_COLOR).withAlpha(0.5),
          },
          label: {
            text: `${AREA_NUM}구역`,
            show: true,
            showBackground: true,
            font: '14px monospace',
            fillColor: Cesium.Color.WHITE,
            horizontalOrigin: Cesium.HorizontalOrigin.LEFT,
            verticalOrigin: Cesium.VerticalOrigin.BOTTOM,
            heightReference: Cesium.HeightReference.RELATIVE_TO_GROUND,
            disableDepthTestDistance: Number.POSITIVE_INFINITY,
            pixelOffset: new Cesium.Cartesian2(0, 0),
          },
          billboard: {
            image: './img/close.png',
            show: true,
            eyeOffset: new Cesium.Cartesian3(0.0, 0.0, 0.0),
            alignedAxis: Cesium.Cartesian3.ZERO,
            width: 30,
            height: 30,
            horizontalOrigin: Cesium.HorizontalOrigin.CENTER,
            verticalOrigin: Cesium.VerticalOrigin.BOTTOM,
            heightReference: Cesium.HeightReference.RELATIVE_TO_GROUND,
            disableDepthTestDistance: Number.POSITIVE_INFINITY,
            pixelOffset: new Cesium.Cartesian2(-16, 0),
          },
        })
        viewer.camera.frustum.near = 1.0
        areaDataSource.entities.add(addEntity)
        areaDraw()
        areaBillboardDelAndHover()
      }
    })
  }

  const buildingDraw = () => {
    if (BUILDING_NUM > 9)
      return
    buildingAction = buildingDrawTool.create(DrawType.Polygon, {
      useDefaultEntity: true,
    })
    buildingAction.on(DrawEventType.Complete, (evt: any) => {
      if (evt) {
        setIsShowModal(true)
        evt.push(evt[0])
        const arr = worldToLngLat(viewer, evt)
        const polygon = turf.polygon([arr])
        const center = turf.centerOfMass(polygon)
        entityCenterLonLat = center.geometry.coordinates
        BUILDING_NUM++
        const addEntity = new Cesium.Entity({
          id: `${POLYGON}_${BUILDING_NUM}`,
          polygon: {
            hierarchy: new Cesium.PolygonHierarchy(evt),
            material: Cesium.Color.fromCssColorString(POLYGON_COLOR).withAlpha(0.5),
          },
        })
        currentBuildingEntity = addEntity
        buildingDataSource.entities.add(addEntity)
        buildingDraw()
        buildingBillboardDelAndHover()
      }
    })
  }

  const setBuildingHeight = (height: number) => {
    // 현재 건물 위치의 중심점을 기반으로 Cartographic 위치를 생성
    const centerPosition = Cesium.Cartographic.fromDegrees(entityCenterLonLat[0], entityCenterLonLat[1])
    // 지형 데이터를 기반으로 지형의 높이를 샘플링
    Cesium.sampleTerrainMostDetailed(viewer.terrainProvider, [centerPosition])
      // Cesium.sampleTerrain(terrainProvider, 13, [centerPosition])
      .then((updatedPositions) => {
        // 샘플링된 지형의 높이를 가져옴
        const terrainHeight = updatedPositions[0].height
        const polygonHierarchy = currentBuildingEntity.polygon.hierarchy.getValue()
        currentBuildingEntity.polygon = new Cesium.PolygonGraphics({
          hierarchy: polygonHierarchy,
          material: Cesium.Color.fromCssColorString(POLYGON_COLOR).withAlpha(0.5),
          height: 0,
          extrudedHeight: height,
          outline: true,
          outlineColor: Cesium.Color.YELLOW,
          heightReference: Cesium.HeightReference.RELATIVE_TO_GROUND,
        })

        const addLabelAndBillboard = new Cesium.Entity({
          id: `${LABEL}_${BUILDING_NUM}`,
          position: Cesium.Cartesian3.fromDegrees(entityCenterLonLat[0], entityCenterLonLat[1], height + 10),
          label: {
            text: `${SPLIT_NAME}${BUILDING_NUM}`,
            show: true,
            showBackground: true,
            font: '14px monospace',
            fillColor: Cesium.Color.WHITE,
            horizontalOrigin: Cesium.HorizontalOrigin.LEFT,
            verticalOrigin: Cesium.VerticalOrigin.BOTTOM,
            heightReference: Cesium.HeightReference.RELATIVE_TO_GROUND,
            disableDepthTestDistance: Number.POSITIVE_INFINITY,
            pixelOffset: new Cesium.Cartesian2(0, 0),
          },
          billboard: {
            image: './img/close.png',
            show: true,
            eyeOffset: new Cesium.Cartesian3(0.0, 0.0, 0.0),
            horizontalOrigin: Cesium.HorizontalOrigin.CENTER,
            verticalOrigin: Cesium.VerticalOrigin.BOTTOM,
            alignedAxis: Cesium.Cartesian3.ZERO,
            width: 30,
            height: 30,
            heightReference: Cesium.HeightReference.RELATIVE_TO_GROUND,
            disableDepthTestDistance: Number.POSITIVE_INFINITY,
            pixelOffset: new Cesium.Cartesian2(-16, 0),
          },
        })
        buildingDataSource.entities.add(addLabelAndBillboard)
      })
  }

  const buildingBillboardDelAndHover = () => {
    const pickHandler = new Cesium.ScreenSpaceEventHandler(viewer.scene.canvas)
    pickHandler.setInputAction((movement: any) => {
      const pick = viewer.scene.pick(movement.position)
      if (pick && pick.primitive && pick.primitive instanceof Cesium.Billboard) {
        buildingAction && buildingAction.destroy() // deleting and drawing polygons overlap
        const pickId = pick.id.id
        const splitArr = pickId.split('_')
        const endNum = splitArr[splitArr.length - 1]
        if (buildingDataSource && buildingDataSource.entities) {
          for (let i = 0; i < buildingDataSource.entities.values.length; i++) {
            const item = buildingDataSource.entities.values[i]
            const delPolygon = `${POLYGON}_${endNum}`
            const delLabel = `${LABEL}_${endNum}`
            if (item.id === delPolygon) {
              buildingDataSource.entities.remove(item)
            }
            if (item.id === delLabel) {
              buildingDataSource.entities.remove(item)
            }
          }
          // edit label.text._value
          const arrFilter = buildingDataSource.entities.values.filter((item: any) => item.id.includes(LABEL))
          arrFilter.forEach((item: any, index: number) => {
            item.label.text._value = SPLIT_NAME + (index + 1)
          })
          buildingDraw()
          BUILDING_NUM--
        }
      }
    }, Cesium.ScreenSpaceEventType.LEFT_CLICK)

    pickHandler.setInputAction((movement: any) => {
      const pick = viewer.scene.pick(movement.endPosition)
      if (pick && pick.primitive && pick.primitive instanceof Cesium.Billboard && pick.id.billboard) {
        pick.id.billboard.image.setValue('./img/closefill.png')
        pickBillboardArea = pick.id.billboard.image
        if (Cesium.defined(pickBillboardArea)) {
          ;(viewer as any)._container.style.cursor = 'pointer'
        }
      }
      else {
        if (pickBillboardArea) {
          pickBillboardArea.setValue('./img/close.png')
          pickBillboardArea = null
        }
        ;(viewer as any)._container.style.cursor = 'default'
      }
    }, Cesium.ScreenSpaceEventType.MOUSE_MOVE)
  }

  const areaBillboardDelAndHover = () => {
    const pickHandler = new Cesium.ScreenSpaceEventHandler(viewer.scene.canvas)

    pickHandler.setInputAction((movement: any) => {
      const pick = viewer.scene.pick(movement.position)
      if (pick && pick.primitive && pick.primitive instanceof Cesium.Billboard) {
        areaAction && areaAction.destroy() // deleting and drawing polygons overlap
        const name = pick.id.name
        if (areaDataSource && areaDataSource.entities) {
          areaDataSource.entities.values.forEach((item: any) => {
            if (item.name.includes(name)) {
              areaDataSource.entities.remove(item)
            }
          })
          areaDataSource.entities.values.forEach((item: any, index: number) => {
            item.name = `${index + 1}구역`
            item.label.text = `${index + 1}구역`
          })
          areaDraw()
          AREA_NUM--
        }
      }
    }, Cesium.ScreenSpaceEventType.LEFT_CLICK)

    pickHandler.setInputAction((movement: any) => {
      const pick = viewer.scene.pick(movement.endPosition)
      if (pick && pick.primitive && pick.primitive instanceof Cesium.Billboard && pick.id.billboard) {
        pick.id.billboard.image.setValue('./img/closefill.png')
        pickBillboardArea = pick.id.billboard.image
        if (Cesium.defined(pickBillboardArea)) {
          ;(viewer as any)._container.style.cursor = 'pointer'
        }
      }
      else {
        if (pickBillboardArea) {
          pickBillboardArea.setValue('./img/close.png')
          pickBillboardArea = null
        }
        ;(viewer as any)._container.style.cursor = 'default'
      }
    }, Cesium.ScreenSpaceEventType.MOUSE_MOVE)
  }

  const clearAreaAll = () => {
    if (areaDataSource && areaDataSource.entities) {
      areaDataSource.entities.removeAll()
    }
    areaAction && areaAction.destroy()
    AREA_NUM = 0
    setIsClickArea(false)
  }

  const clearBuildingAll = () => {
    if (buildingDataSource && buildingDataSource.entities) {
      buildingDataSource.entities.removeAll()
    }
    buildingAction && buildingAction.destroy()
    BUILDING_NUM = 0
    setIsClickBuilding(false)
    setIsShowModal(false)
  }

  const onAreaFn = () => {
    clearAreaAll()
    clearBuildingAll()
    if (!isClickArea) {
      setIsClickArea(true)
    }
    else {
      setIsClickArea(false)
    }
  }

  const offAreaFn = () => {
    clearAreaAll()
    clearBuildingAll()
    if (!isClickArea) {
      setIsClickArea(true)
    }
    else {
      setIsClickArea(false)
    }
    areaDraw()
  }

  const onBuildingFn = () => {
    clearAreaAll()
    clearBuildingAll()
    if (!isClickBuilding) {
      setIsClickBuilding(true)
    }
    else {
      setIsClickBuilding(false)
    }
  }

  const offBuildingFn = () => {
    clearBuildingAll()
    clearAreaAll()
    if (!isClickBuilding) {
      setIsClickBuilding(true)
    }
    else {
      setIsClickBuilding(false)
    }
    buildingDraw()
  }

  const renderEditContent = () => {
    return (
      <div style={{ display: 'flex', justifyContent: 'space-between', width: 116 }}>
        <div>
          <Popover trigger={'hover'} placement="top" content={'구역그리기'}>
            {isClickArea
              ? (
              <img alt={'구역그리기'} src={icon_area_on} className={`${prefix}-img`} onClick={onAreaFn} />
                )
              : (
              <img alt={'구역그리기'} src={icon_area} className={`${prefix}-img`} onClick={offAreaFn} />
                )}
          </Popover>
        </div>
        <div>
          <Popover trigger={'hover'} placement="top" content={'건물그리기'}>
            {isClickBuilding
              ? (
              <img alt={'건물그리기'} src={icon_building_on} className={`${prefix}-img`} onClick={onBuildingFn} />
                )
              : (
              <img alt={'건물그리기'} src={icon_building} className={`${prefix}-img`} onClick={offBuildingFn} />
                )}
          </Popover>
        </div>
      </div>
    )
  }

  const handleTabClick = (tabKey: string) => {
    setActiveTab(tabKey)
    if (tabKey === TAB2) {
      if (populationArr.length > 0) {
        const id = localStorage.getItem('JSESSIONID') || ''

        const obj = {
          apiKey: window.SystemConfig.facilityApiKey,
          sidoCd: populationArr[0].sidoCd,
          sessionId: isDev ? `${window.SystemConfig.facilitySessionId}` : id,
        }
        IGetBusiness(obj).then((res: any) => {
          if (res.code === 200) {
            const obj = res.result
            if (obj.corpCntRankList && obj.corpCntRankList.length > 0) {
              const title = '1위 업종'
              const title2 = '2위 업종'
              const title3 = '3위 업종'
              const name = findValue(obj.corpCntRankList, 'corpCntRank', 1, 'themeNm')
              const name2 = findValue(obj.corpCntRankList, 'corpCntRank', 2, 'themeNm')
              const name3 = findValue(obj.corpCntRankList, 'corpCntRank', 3, 'themeNm')

              const value = findValue(obj.corpCntRankList, 'corpCntRank', 1, 'corpCnt')
              const value2 = findValue(obj.corpCntRankList, 'corpCntRank', 2, 'corpCnt')
              const value3 = findValue(obj.corpCntRankList, 'corpCntRank', 3, 'corpCnt')
              const res = []
              const arr = [
                { title, name, value: value.toLocaleString() },
              ]
              const arr2 = [
                { title: title2, name: name2, value: value2.toLocaleString() },
              ]
              const arr3 = [
                { title: title3, name: name3, value: value3.toLocaleString() },
              ]
              res.push(arr)
              res.push(arr2)
              res.push(arr3)
              setContentArr5(res)
            }
            else {
              setContentArr5(contentArr5Copy)
            }

            if (obj.corpPerRankList && obj.corpPerRankList.length > 0) {
              const title = '1위 업종'
              const title2 = '2위 업종'
              const title3 = '3위 업종'
              const name = findValue(obj.corpPerRankList, 'corpPerRank', 1, 'themeNm')
              const name2 = findValue(obj.corpPerRankList, 'corpPerRank', 2, 'themeNm')
              const name3 = findValue(obj.corpPerRankList, 'corpPerRank', 3, 'themeNm')

              const value = findValue(obj.corpPerRankList, 'corpPerRank', 1, 'corpPer')
              const value2 = findValue(obj.corpPerRankList, 'corpPerRank', 2, 'corpPer')
              const value3 = findValue(obj.corpPerRankList, 'corpPerRank', 3, 'corpPer')
              const res = []
              const arr = [
                { title, name, value: value ? `${value}%` : `${value}%` },
              ]
              const arr2 = [
                { title: title2, name: name2, value: value2 ? `${value2}%` : `${value2}%` },
              ]
              const arr3 = [
                { title: title3, name: name3, value: value3 ? `${value3}%` : `${value3}%` },
              ]
              res.push(arr)
              res.push(arr2)
              res.push(arr3)
              setContentArr6(res)
            }
            else {
              setContentArr6(contentArr6Copy)
            }

            if (obj.corpIrdsRankList && obj.corpIrdsRankList.length > 0) {
              const title = '1위 업종'
              const title2 = '2위 업종'
              const title3 = '3위 업종'
              const name = findValue(obj.corpIrdsRankList, 'corpIrdsRank', 1, 'themeNm')
              const name2 = findValue(obj.corpIrdsRankList, 'corpIrdsRank', 2, 'themeNm')
              const name3 = findValue(obj.corpIrdsRankList, 'corpIrdsRank', 3, 'themeNm')

              const value = Number.parseInt(findValue(obj.corpIrdsRankList, 'corpIrdsRank', 1, 'corpIrdsrate'))
              const value2 = Number.parseInt(findValue(obj.corpIrdsRankList, 'corpIrdsRank', 2, 'corpIrdsrate'))
              const value3 = Number.parseInt(findValue(obj.corpIrdsRankList, 'corpIrdsRank', 3, 'corpIrdsrate'))
              const res = []
              const arr = [
                { title, name, value: value > 0 ? `↑${value}%` : `↓${value}%` },
              ]
              const arr2 = [
                { title: title2, name: name2, value: value2 > 0 ? `↑${value2}%` : `↓${value2}%` },
              ]
              const arr3 = [
                { title: title3, name: name3, value: value3 > 0 ? `↑${value3}%` : `↓${value3}%` },
              ]
              res.push(arr)
              res.push(arr2)
              res.push(arr3)
              setContentArr7(res)
            }
            else {
              setContentArr7(contentArr7Copy)
            }
          }
        })
      }
    }
  }

  const findValue = (arr: any, label: string, value: number, res: string) => {
    let find = ''
    arr.forEach((item: any) => {
      if (item[label] === value) {
        find = item[res]
      }
    })
    return find
  }

  return (
    <rightNavContext.Provider
      value={{
        viewer,
      }}
    >
      <div
        className={`${prefix}-imageLayer`}
      >
        <Button
          style={{
            background: cadastral ? '#10120b' : 'rgba(255, 255, 255, 0.8)',
            color: cadastral ? '#fff' : '#212529',
            borderColor: cadastral ? 'transparent' : '',
          }}
          onClick={addImageLayer}
        >
          <span translate="no"> 연속 지적도</span>
        </Button>
        <Button
          style={{
            background: isClickPlot ? '#10120b' : 'rgba(255, 255, 255, 0.8)',
            color: isClickPlot ? '#fff' : '#212529',
            borderColor: isClickPlot ? 'transparent' : '',
          }}
          onClick={getPlotData}>
          <span translate="no"> 토지이용현황도</span>
        </Button>
        <Button
          style={{
            background: showProvince ? '#10120b' : 'rgba(255, 255, 255, 0.8)',
            color: showProvince ? '#fff' : '#212529',
            borderColor: showProvince ? 'transparent' : '',
          }}
          onClick={handleLoadProvince}
        >
          시군농촌정보조회
        </Button>
        {isClickPlot
          ? (
          <ul className={`${prefix}-imageLayer-list`} style={{ display: isClickPlot ? 'block' : 'none' }}>
            {addressArr.map((item: any, index: number) => (
              <li key={index} className={`${prefix}-imageLayer-list-item`}>
                <label className={`map-chk partOne${index}`}>{item.label}</label>
                <Radio
                  onChange={(e) => {
                    setRadioValue(e.target.value)
                  }}
                  value={item.value}
                  checked={item.value === radioValue}
                ></Radio>
              </li>
            ))}
          </ul>
            )
          : null}
      </div>
      <div className={`${prefix}`}>
        <div className={`${prefix}-compass`} onClick={handleArrowN}>
          <img alt="icon" src={icon_compass} className={`${prefix}-compass-icon`} />
          <img src={navigation_outline} alt="" style={{ transform: `rotate(${deg}deg)` }} className={`${prefix}-compass-spin`} />
        </div>
        <div className={`${prefix}-shadow`}>
          <Popover placement="left" content={isShadow ? SHADOW_TEXT + ON : SHADOW_TEXT + OFF}>
            {isShadow
              ? (
              <img alt="icon" src={shadow_on} className={`${prefix}-img`} onClick={handleClickShadow} />
                )
              : (
              <img alt="icon" src={shadow_off} className={`${prefix}-img`} onClick={handleClickShadow} />
                )}
          </Popover>
        </div>
        <div className={`${prefix}-lod1`}>
          <Popover placement="left" content={isLod1 ? LOD1_TEXT + ON : LOD1_TEXT + OFF}>
            {isLod1
              ? (
              <img alt={'LOD1 ON'} src={icon_lod_on} className={`${prefix}-img`} onClick={handleClickLod1} />
                )
              : (
              <img alt={'LOD1 OFF'} src={icon_lod_off} className={`${prefix}-img`} onClick={handleClickLod1} />
                )}
          </Popover>
        </div>
        <div className={`${prefix}-model`}>
          <Popover
            placement="left"
            trigger="hover"
            open={openModel}
            onOpenChange={openModelFn}
            content={
              <Popover placement="top" content={'숨기기 취소'}>
                <img alt={'close'} src={icon_close} className={`${prefix}-img`} onClick={closeModelFn} />
              </Popover>
            }
          >
            {isModel
              ? (
              <img alt={'model ON'} src={icon_model_on} className={`${prefix}-img`} onClick={handleClickModel} />
                )
              : (
              <img alt={'model OFF'} src={icon_model_off} className={`${prefix}-img`} onClick={handleClickModel} />
                )}
          </Popover>
        </div>
        <div className={`${prefix}-analyze`}>
          <Popover open={isAnalysisPopover} destroyTooltipOnHide trigger="click" placement="left" content={() => renderAnalysis()}>
            {isAnalysisPopover
              ? (
              <img alt={'analyze ON'} src={icon_analyze_on} className={`${prefix}-img`} onClick={handleClickAnalyze} />
                )
              : (
              <img alt={'analyze OFF'} src={icon_analyze_off} className={`${prefix}-img`} onClick={handleClickAnalyze} />
                )}
          </Popover>
        </div>
        <div className={`${prefix}-measure`}>
          <Popover
          open={isMeasurePopover}
          destroyTooltipOnHide trigger="click" placement="left" content={() => renderMeasure()}>
            {isMeasurePopover
              ? (
              <img alt={'measure ON'} src={icon_measure_on} className={`${prefix}-img`} onClick={handleClickMeasure} />
                )
              : (
              <img alt={'measure OFF'} src={icon_measure_off} className={`${prefix}-img`} onClick={handleClickMeasure} />
                )}
          </Popover>
        </div>
        <div className={`${prefix}-screen`}>
          <img alt={'screen'} src={icon_screen} className={`${prefix}-img`} onClick={handleClickScreen} />
        </div>
        <div className={`${prefix}-edit`}>
          <Popover
          open={isEditPopover}
          destroyTooltipOnHide
          trigger="click" placement="left" content={() => renderEditContent()}>
            {isEditPopover
              ? <img alt={'isEditPopover ON'} src={icon_pen_on} className={`${prefix}-img`} onClick={handleClickEdit} />
              : <img alt={'isEditPopover OFF'} src={icon_pen} className={`${prefix}-img`} onClick={handleClickEdit} />}
          </Popover>
        </div>
        <div className={`${prefix}-plus`}>
          <img alt={'plus'} src={icon_plus} className={`${prefix}-img`} onClick={() => clickZoomIn('in')} />
        </div>
        <div className={`${prefix}-minus`}>
          <img alt={'minus'} src={icon_minus} className={`${prefix}-img`} onClick={() => clickZoomIn('out')} />
        </div>
      </div>

      {(isAn1 || isAn2 || isAn3 || isAn4 || isAn5 || isAn6 || isMe1 || isMe2 || isMe3 || isMe4 || isMe5) && <AnalysisAndMeasure
        ref={analysisAndMeasureRef}
      ></AnalysisAndMeasure>}
      {isLoading && <Loading></Loading>}
      {isShowModal && (
        <Modal
          visible={isShowModal}
          headerTitle={'건물 그리기'}
          handleClose={() => {
            setIsShowModal(false)
            buildingDataSource.entities.remove(currentBuildingEntity)
            buildingDraw()
          }}
          styles={{
            position: 'fixed',
            width: 200,
            top: `${window.SystemConfig.uiConfig.headerHeight + 30}px`,
            left: `${uiStore.Content_Left_Width + 30}px`,
            zIndex: 10,
          }}
          isNotDragWithParent="dragModal_rightNavCtrl"
        >
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <InputNumber
             style={{ width: '80px' }}
              min={1}
              value={inputValue}
              onChange={(e) => {
                setInputValue(e || inputValue)
              }}
            ></InputNumber>
            m
            <Button
              style={{ marginLeft: '30px' }}
              onClick={() => {
                setIsShowModal(false)
                setBuildingHeight(inputValue)
                buildingDraw()
                setInputValue(10)
              }}
            >
              높이 입력
            </Button>
          </div>
        </Modal>
      )}
      {isShowModal2 && (
        <Modal
          visible={isShowModal2}
          headerTitle={'농촌 정보 조회'}
          handleClose={() => {
            setIsShowModal2(false)
          }}
          styles={{
            position: 'fixed',
            width: 600,
            top: `${window.SystemConfig.uiConfig.headerHeight + 30}px`,
            left: `${uiStore.Content_Left_Width + 30}px`,
            zIndex: 10,
          }}
          isNotDragWithParent="dragModal_rightNavCtrl_2"
        >
          <div className={`${prefix}-modal2`}>
            <header>{title}</header>
            <div className={`${prefix}-modal2-tabs`}>
              <div className={`${prefix}-modal2-tabs-btn`}>
                <Button onClick={() => handleTabClick(TAB1)} className={`${prefix}-modal2-tabs-btn-left ${activeTab === TAB1 ? 'active' : ''}`}>
                  인구정보
                </Button>
                <Button onClick={() => handleTabClick(TAB2)} className={`${prefix}-modal2-tabs-btn-right ${activeTab === TAB2 ? 'active' : ''}`}>
                  사업체 정보
                </Button>
              </div>
              <div className={`${prefix}-modal2-tabs-content`}>
                {activeTab === TAB1 && (
                  <div className={`${prefix}-modal2-tabs-content-one`}>
                    <div className={`${prefix}-modal2-tabs-content-one-box`}>
                      <header>인구 정보 개요</header>
                      <RenderKeyValue2Array contentArr={contentArr2} />
                    </div>
                    <div className={`${prefix}-modal2-tabs-content-two`}>
                      <header>인구 정보 상세</header>
                      <RenderKeyValue2Array contentArr={contentArr3} />
                    </div>
                  </div>
                )}
                {activeTab === TAB2 && (
                  <div className={`${prefix}-modal2-tabs-content-tabs2`}>
                    <div className={`${prefix}-modal2-tabs-content-tabs2-two`}>
                      <header>업종 순위</header>
                      <RenderKeyValue2Array2 contentArr={contentArr5} />
                    </div>
                    <div className={`${prefix}-modal2-tabs-content-tabs2-three`}>
                      <header>업종 비율 순위</header>
                      <RenderKeyValue2Array2 contentArr={contentArr6} />
                    </div>
                    <div className={`${prefix}-modal2-tabs-content-tabs2-four`}>
                      <header>업종 증감 순위</header>
                      <RenderKeyValue2Array2 contentArr={contentArr7} />
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </Modal>
      )}
    </rightNavContext.Provider>
  )
}

export default observer(RightNavCtrl)
